import React from 'react';
import {useParams, useNavigate} from "react-router-dom";
import {auth} from '../../../store/auth.store';
import paths from "../../../paths";
import {ApiService} from 'lib/http.service';
import {env} from '../../../constants/global.vars';
import {gtmSelectItem, gtmViewItemList} from "../../../services/misc.functions";
import iconRight from "../../../assets/feather/arrow-right.svg";

const SisalScratchPlayer = ({slug, isArchive = false}: { slug: string; isArchive?: boolean }) => {
    const accountId = auth.member.id;
    const userToken = auth.token;
    const widgetUrl = `${window.location.origin}/game-widget/game-widget.html?token=${userToken}&vendor=${9}&code=${slug}&userId=${accountId}`;

    return (
        <div className="page-widget vr-game-page" style={{minHeight: '80vh', height: '100%'}}>
            <iframe
                title='Game Loader'
                style={{width: '100%', height: '100%', border: 'none', minHeight: '80vh', zIndex: 9999}}
                allow="fullscreen; autoplay"
                src={widgetUrl}
            />
        </div>
    );
};

export default function SisalScratch() {
    const params = useParams();
    const activeSlug = params.subpage;
    const navigate = useNavigate();
    const [gamesList, setGamesList] = React.useState<any[]>([]);
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        const getGames = async () => {
            const res: any = await new ApiService().start("post", env.accounting_api + "/games/api/list-game/", {
                vendor: 9,
            }, false);
            if (res && res.status) {
                setGamesList(res.data);
                gtmViewItemList(res.data, "Oyun");
            }
            setLoading(false);
        };
        getGames();
    }, []);

    if (activeSlug) {
        return <SisalScratchPlayer slug={activeSlug} isArchive={false}/>;
    }

    return (
        <div className="page-widget">
            <svg style={{display: "none"}}>
                <defs>
                    <path id="tabshape" d="M80,60C34,53.5,64.417,0,0,0v60H80z"></path>
                </defs>
            </svg>
            <div className={"tab-scroll"}>
                {/* Tab Header */}
                <ul className="nav nav-tabs">
                    <li
                        key={`tabs`}
                        className={`nav-item active`}
                    >
                        <svg className="left" viewBox="0 0 80 60" preserveAspectRatio="none">
                            <use xlinkHref="#tabshape"></use>
                        </svg>
                        <a className="nav-link" id={`011`}>
                            Kazı Kazan
                        </a>
                        <svg className="right" viewBox="0 0 80 60" preserveAspectRatio="none">
                            <use xlinkHref="#tabshape"></use>
                        </svg>
                    </li>
                </ul>
            </div>

            {loading ? (
                <div className="text-white px-4">Oyunlar yükleniyor...</div>
            ) : (
                <div className={"row m-2"}>
                    {gamesList.map((game: any, key: number) => {
                        return (
                            <div key={`games-list-${key}`} className="col-6 col-lg-3 mb-4">
                                <div className="game-widget">
                                    <img
                                        className="games pointer"
                                        src={`${env.cdn_host}/media/${game.image}`}
                                        alt={game.name}
                                        onClick={() => {
                                            if (game.is_active) {
                                                navigate(`${paths.sisalscratch.url}/${game.code}`);
                                                gtmSelectItem([game], "Oyunlar");
                                            }
                                        }}
                                    />
                                    <div className="playable body mt-2">
                                        <span
                                            className="label text-decoration-none text-black pointer"
                                            onClick={() => {
                                                if (game.is_active) {
                                                    navigate(`${paths.sisalscratch.url}/${game.code}`);
                                                    gtmSelectItem([game], "Oyunlar");
                                                }
                                            }}>
                                            Hemen Oyna
                                        </span>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            )}
        </div>
    );
}
